
import { dateFormatter } from "../utils/formatters";

const historicPlottingRanges = ["5D", "1M", "6M", "YTD", "1Y", "5Y", "MAX"]

const chartTypeToggleOptions = [{ label: "Price", value: "price" }, { label: "Yield", value: "yield" }]

const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            type: "time",
            time: {
                minUnit: "day",
                tooltipFormat: "dd-MM-yyyy",
                displayFormats: {
                    day: "dd-MM-yyyy",
                    month: "MMM yyyy",
                    year: "yyyy",
                },
            },
            ticks: {
                maxTicksLimit: 5
            }
        },
        y: {
            ticks: { stepSize: 0.5 },
        }
    },
    plugins: {
        zoom: {
            zoom: {
                wheel: { enabled: true },
                pinch: { enabled: true },
                mode: 'x',
            },
            pan: {
                enabled: true,
                mode: 'x',
            },
            drag: {
                enabled: true,
                mode: 'x',
            },
            limits: {
                x: { min: 'original', max: 'original' },
            },
        },
        legend: {
            labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 8,
                boxHeight: 8,
                padding: 8,
            },
        },
        tooltip: {
            enabled: true,
            position: 'smart',
            intersect: false,
            mode: 'nearest',
            caretSize: 0,
            displayColors: false,
            backgroundColor: 'rgba(30, 30, 30, 0.85)',
            titleColor: '#ffffff',
            titleFont: { size: 13, weight: '600', family: 'Roboto, sans-serif' },
            bodyColor: '#f5f5f5',
            bodyFont: { size: 12, family: 'Roboto, sans-serif' },
            padding: 12,
            cornerRadius: 4,
            borderColor: 'rgba(255, 255, 255, 0.08)',
            borderWidth: 1,
            boxPadding: 4,
            bodySpacing: 6,
            titleSpacing: 4,
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            shadowBlur: 12,
            shadowColor: 'rgba(0, 0, 0, 0.35)',
            callbacks: {
                title: (items) => {
                    const rawX = new Date(items[0].parsed.x);
                    return dateFormatter(rawX, "long")
                },
                label: (context) => `Value: ${context.parsed.y.toFixed(2)}`,
            },
            animation: {
                duration: 180,
                easing: 'easeOutCubic',
            },
        },
    },
    elements: {
        point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4
        },
    },
    interaction: {
        mode: 'nearest',
        intersect: false,
    },
}

export {
    chartOptions,
    chartTypeToggleOptions,
    historicPlottingRanges
}